import barba from '@barba/core';
import scripts from "./scripts";

function delay(n) {
    n = n || 500;
    return new Promise((done) => {
        setTimeout(() => {
            done();
        }, n);
    });
}

if ($('.logged-in.admin-bar').length < 1) {

    barba.init({
        transitions: [{
            sync: false,

            //Load la premiere fois que le site run
            async once(data) {
                scripts();
            },

            //Before everything
            async before() {

            },

            //Before Leave transition/view
            async beforeLeave(data) {

            },

            async leave(data) {

                const done = this.async();

                $('.menu li').each(function () {
                    $(this).removeClass('current-menu-item');

                    if ($(this).find('a')[0].pathname == data.next.url.path) {
                        $(this).addClass('current-menu-item');
                    }
                });

                TweenMax.fromTo($('main'), 1, {
                    opacity: 1
                }, {
                    opacity: 0,
                })

                TweenMax.fromTo($('.c-animation__general'), .8, {
                    scaleX: 0,
                }, {
                    scaleX: 1,
                    transformOrigin: 'left',
                    ease: Power3.easeInOut
                });

                setTimeout(function () {
                    TweenMax.fromTo($('.c-animation__general'), .8, {
                        scaleX: 1,
                    }, {
                        scaleX: 0,
                        transformOrigin: 'right',
                        ease: Power3.easeInOut
                    });

                    TweenMax.fromTo($('main'), 1, {
                        opacity: 0
                    }, {
                        opacity: 1,
                        delay: .6
                    })
                }, 800)

                await delay(600);
                done();
            },

            //After leave transition/view (next container is DOM ready)
            async afterLeave(data) {

                //Change body Class
                var nextHtml = data.next.html;
                var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml)
                var bodyClasses = $(response).filter('notbody').attr('class')

                $("body").attr("class", bodyClasses);

                var $newPageHead = $('<head />').html($.parseHTML(data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0], document, true));


                //Update meta Head
                var headTags = [
                    "script[src*='uutils.fcg']",
                    "meta[name='keywords']",
                    "meta[name='description']",
                    "meta[property^='og']",
                    "meta[name^='twitter']",
                    'meta[itemprop]',
                    'link[itemprop]',
                    "link[rel='prev']",
                    "link[rel='next']",
                    "link[rel='canonical']",
                ].join(',');
                $('head').find(headTags).remove();
                $newPageHead.find(headTags).appendTo('head');

                /*
                    ga('set', 'page', window.location.pathname);
                    ga('send', 'pageview');

                 */
            },

            //Before enter transition/view
            async beforeEnter(data) {

            },

            //Next page enter transition
            async enter(data) {

            },

            //After enter transition/view
            async afterEnter(data) {

            },

            //	Current page leave transition
            async after(data) {

                scripts();

                $('.menu li').each(function () {
                    $(this).removeClass(['current-menu-item', 'current_page_item']);

                    if ($(this).find('a')[0].pathname == data.next.url.path) {
                        $(this).addClass(['current-menu-item', 'current_page_item']);
                    }
                });
            },
        }]
    });
} else {
    $(document).ready(function () {
        scripts();
    });
}
